import {useEffect, useMemo, useState} from "react";
import axios from "axios";
import {Card, CardBody, Select, Option, ListItem} from "@material-tailwind/react";
import getData from "../../api/axiosInstance";
import {useTheme} from "../common/ThemeContext";

export default function InStockSummaryCard() {
    const [internalNumbers, setInternalNumbers] = useState([]);
    const [selectedNumber, setSelectedNumber] = useState("");
    const [summary, setSummary] = useState(null);
    const { isDark } = useTheme();

    const token = localStorage.getItem("token");

    const headers = useMemo(() => {
        return {
            'Authorization': `Bearer ${token}`
        };
    }, [token]);


    useEffect(() => {
        getData(
            "/purchased_items/unique_internal_numbers",
            headers,
            (data) => {
                if (data.length > 0) {
                    const sortedData = data.sort((a, b) =>
                        new Date(b.availabilityDate) - new Date(a.availabilityDate)
                    );
                    setInternalNumbers(sortedData);
                    setSelectedNumber(sortedData[0].internalNumber); // Automatski selektuj prvi (najnoviji)
                }
            },
            "Error fetching internal numbers"
        );
    }, [headers]);

    useEffect(() => {

        const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/arcado_admin";

        if (!selectedNumber) return; // Ne pozivaj fetchSummary dok selectedNumber nije odabran
        axios.get(
            `${API_URL}/purchased_items/in_stock_summary`,
            {
                params: { internalNumber: selectedNumber },
                headers
            }
        ).then(response => {
            setSummary(response.data);
        }).catch(error => console.error("Error fetching summary:", error));
    }, [selectedNumber, headers]);

    useEffect(() => {
        if (internalNumbers.length > 0 && !selectedNumber) {
            setSelectedNumber(internalNumbers[0].internalNumber);
        }
    }, [internalNumbers, selectedNumber]);
    

    return (
        <Card className="w-full shadow-[0_0_15px_rgba(0,0,0,0.1)] relative overflow-hidden dark:bg-dark-900">
            <CardBody>
                <div className="flow-root">
                    <div className="flex items-center mt-5 w-full gap-2 md:w-max">
                        {internalNumbers.length > 0 && (
                            <Select
                                label="Yugotransport Internal Number"
                                className="placeholder:text-blue-gray-300 dark:text-white dark:bg-dark-800"
                                labelProps={{
                                    className: "dark:text-gray-300"
                                }}
                                color={isDark ? "gray" : "blue-gray"}
                                value={selectedNumber}
                                onChange={(value) => setSelectedNumber(value)}
                                menuProps={{
                                    className: "dark:bg-dark-800 dark:border-gray-600 max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 dark:scrollbar-thumb-gray-600 dark:scrollbar-track-dark-800"
                                }}
                            >
                                {internalNumbers.map((item) => (
                                    <Option
                                        key={item.internalNumber}
                                        value={item.internalNumber}
                                        className="dark:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700 dark:[&[data-selected='true']]:bg-cyan-800 dark:[&[data-selected='true']]:text-white"
                                    >
                                        {item.internalNumber} -{" "}
                                        {new Date(item.availabilityDate).toLocaleDateString("sr-RS", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        })}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </div>

                    {summary && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 lg:gap-32">
                            {/* Leva strana */}
                            <div className="w-full">
                                <ul className="divide-y divide-gray-200 dark:divide-gray-800 mt-5">

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Price Fees
                                                </p>
                                            </div>

                                            {/* Cena - pozicionirana 65% od širine */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.priceFeesTotal)
                                                        ? summary.priceFeesTotal.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.priceFeesInRsdTotal)
                                                        ? summary.priceFeesInRsdTotal.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-auto">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>


                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Shipping Fees
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.shippingFeesTotal)
                                                        ? summary.shippingFeesTotal.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.shippingFeesInRsdTotal)
                                                        ? summary.shippingFeesInRsdTotal.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Parcel Forwarding Fees
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.parcelForwardingFeesTotal)
                                                        ? summary.parcelForwardingFeesTotal.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.parcelForwardingFeesInRsdTotal)
                                                        ? summary.parcelForwardingFeesInRsdTotal.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Fees
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.totalFees)
                                                        ? summary.totalFees.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.totalFeesInRsd)
                                                        ? summary.totalFeesInRsd.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Price
                                                </p>
                                            </div>

                                            {/* Cena - pozicionirana 65% od širine */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.totalPrice)
                                                        ? summary.totalPrice.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.totalPriceInRsd)
                                                        ? summary.totalPriceInRsd.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-auto">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Cost After Fees
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.totalCostAfterFees)
                                                        ? summary.totalCostAfterFees.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.totalCostAfterFeesInRsd)
                                                        ? summary.totalCostAfterFeesInRsd.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>
                                </ul>
                            </div>

                            {/* Desna strana */}
                            <div className="w-full">
                                <ul className="divide-y divide-gray-200 dark:divide-gray-800 mt-5">

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Expected Selling Price
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.totalExpectedSellingPrice)
                                                        ? summary.totalExpectedSellingPrice.toLocaleString('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.totalExpectedSellingPriceInRsd)
                                                        ? summary.totalExpectedSellingPriceInRsd.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>


                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Total Selling Price for Sold Items
                                                </p>
                                                <p className="text-md font-medium text-gray-500 truncate dark:text-gray-600">
                                                    Profit
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.totalSellingPriceInRsd)
                                                        ? summary.totalSellingPriceInRsd.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.totalSellingPriceInRsd)
                                                        ? (summary.totalSellingPriceInRsd - summary.totalCostAfterFeesInRsd).toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Items Count
                                                </p>
                                                <p className="text-md font-medium text-gray-500 truncate dark:text-gray-600">
                                                    Items Count Without Personal Items
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.itemCount)
                                                        ? summary.itemCount
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.itemCountExcludingInStockPersonal)
                                                        ? summary.itemCountExcludingInStockPersonal
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-gray-300">
                                                    Sold Items Count
                                                </p>
                                                <p className="text-md font-medium text-gray-500 truncate dark:text-gray-600">
                                                    In Stock Items Count
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.soldItemCount)
                                                        ? summary.soldItemCount
                                                        : '/'}
                                                </div>
                                                {/* Dodavanje cene u RSD ispod */}
                                                <div className="text-sm text-gray-500 font-bold">
                                                    {Number.isFinite(summary.inStockItemCount)
                                                        ? summary.inStockItemCount
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>

                                    <li className="py-1.5">
                                        <ListItem className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 hover:bg-green-50">
                                            {/* Tekst - levo */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-md font-medium text-gray-900 truncate dark:text-white">
                                                    Average Margin Percent For Sold Items
                                                </p>
                                            </div>

                                            {/* Cena - centrirano */}
                                            <div className="w-[32%] text-left py-1 mx-4">
                                                <div className="text-sm text-gray-900 dark:text-gray-300 font-bold mb-1">
                                                    {Number.isFinite(summary.averageMarginPercent)
                                                        ? (summary.averageMarginPercent).toFixed(2) + '%'
                                                        : '/'}
                                                </div>
                                            </div>

                                            {/*<div className="ml-2">*/}
                                            {/*    <ArrowLongRightIcon className="h-5 w-5 text-cyan-800" />*/}
                                            {/*</div>*/}
                                        </ListItem>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
}